import React, {useEffect, useRef,useState } from "react"; 
import  {gameFileUpdate} from "../../../Services/gameServices"
import { toast } from "react-toastify"; 
import { checkPermissions } from "../../../Services/User/User";
const GameFileUpdate = ({game_id,rerender}) => { 
    const fileInputRef = useRef(null);
    const [asset,setAsset]              = useState(null)
    const [assetError, setAssetError]   = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const MAX_FILE_SIZE = 500 * 1024 * 1024; 
    const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
        if (!selectedFile) {
            setAssetError("Please provide a file.");
            setAsset(null);
            return;
        }
        if (!selectedFile.name.endsWith(".zip")) {
            toast.error("Please provide a .zip format file only.");
            setAsset(null);
            e.target.value = null;
            return;
        }
        if (selectedFile.size > MAX_FILE_SIZE) {
            toast.error("File size should not exceed 500MB.");
            setAsset(null);
            e.target.value = null;
            return;
        }
        setAssetError("");
        setAsset(selectedFile);
    };
      const updateGameFile = () => {
        if (!asset) {
            setAssetError(true);
            return;
        } 
        const formData = new FormData();
        formData.append("game_id", game_id);
        formData.append("game", asset); 
        setIsloading(true); 
        gameFileUpdate(formData)
            .then((data) => {
                setIsloading(false);
                setAsset(null); 
                if (data?.status) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Reset input field
                    }
                    toast.success(data.message);
                    rerender();
                } else {
                    toast.error(data.errorMessage || "Failed to update game file.");
                }
            })
            .catch((error) => {
                setIsloading(false);
                console.error("Game file update failed:", error);
                toast.error("An error occurred while updating the game file.");
            });
    };
    
  return (
    <div className="card">
    <div className="card-body" style={{ padding: '20px' }}>
        <form className="row g-3" id="updateeGameForm" method="post" encType="multipart/form-data">
            <div className="col-12 px-3">
                <label htmlFor="NewGameFile" className="form-label">Select Game File</label>
                <input 
                 ref={fileInputRef} onChange={handleFileChange} type="file"  className="form-control"  accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed" />
                <div className="new-game-file invalid-feedback"  style={{ display: assetError ? 'block' : 'none' }}>Please provide file.</div>
               </div> 
        </form>
        <br />
        {checkPermissions('game_file_update') && 
        <div className="modal-footer"> 
        <button  style={{ display: isLoading ? 'block' : 'none' }} className="btn btn-primary" type="button" disabled>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Uploading...
        </button> 
            <button style={{ display: !isLoading ? 'block' : 'none' }}  onClick={updateGameFile} type="submit" className="btn btn-primary">Update</button>
        </div>
        }
    </div>
</div>
  );
};

export default GameFileUpdate;